module.exports = __webpack_public_path__ + "5ba111974e7d66ed06f4e86cade45ca3.gif";